import type { FC } from 'react'
import { ExpandImageButton } from '@/components/commons/expand-image-button'
import { ImageCard } from '@/components/commons/image-card'
import { ButtonLegacy } from '@/components/ui/button-legacy'
import { ImageCardFlags } from '@/features/photoset/components/image-card-flags'
import { usePhotosetStore } from '@/features/photoset/store/store'
import { type Image, StepKey } from '@/features/photoset/types'
import { useTranslation } from '@/translations/i18n'

interface CurationPhotosetSpaceImagesProps {
	images: Omit<Image, 'space'>[]
	spaceId: number
	spaceIndex: number
	onExpandImage: (spaceIndex: number, imageIndex: number) => void
	cbSetHideAllUnselected: () => void
}

export const CurationPhotosetSpaceImages: FC<
	CurationPhotosetSpaceImagesProps
> = ({
	images,
	spaceId,
	spaceIndex,
	onExpandImage,
	cbSetHideAllUnselected
}) => {
	const { t } = useTranslation()
	const photosetSpaceImageSelectionToggle = usePhotosetStore(
		(state) => state.photosetSpaceImageSelectionToggle
	)

	return images.length === 0 ? (
		<div className='z-[1] flex w-full flex-col items-center gap-3 rounded border border-neutral-200 bg-neutral-100 py-12 [&>h3]:font-medium [&>h3]:text-lg [&>h3]:text-neutral-900 [&>p]:text-neutral-600 [&>p]:text-sm'>
			<h3>{t('photoset:curation.space.no_images_title')}</h3>
			<p>{t('photoset:curation.space.hidden_images_des')}</p>
			<ButtonLegacy
				onClick={() => cbSetHideAllUnselected()}
				type='button'
				variant='secondary'
			>
				{t('photoset:curation.space.show_unselected')}
			</ButtonLegacy>
		</div>
	) : (
		<div className='grid w-full grid-cols-[repeat(4,minmax(0,1fr))]'>
			{images.map((image, index) => {
				return (
					<ImageCard
						endSlot={
							<>
								<ExpandImageButton
									onClick={() =>
										onExpandImage(spaceIndex, index)
									}
								/>
								<ImageCardFlags
									image={image}
									photosetSpaceIds={[spaceId]}
									stepId={StepKey.curation}
								/>
							</>
						}
						hideCheckbox={!image.thumbnails?.xs}
						image={image}
						isSelected={image.is_final_select}
						key={image.id}
						onSelect={() =>
							photosetSpaceImageSelectionToggle(
								spaceIndex,
								image.id
							)
						}
						thumbnail={image.thumbnails?.xs}
					/>
				)
			})}
		</div>
	)
}
